/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetUsers200, GetUsers400, GetUsersQueryResponse } from '../entities/GetUsers'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { getUsersResponseSchema } from './getUsersResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const getUsers200Schema = z.lazy(() => getUsersResponseSchema) as unknown as ToZod<GetUsers200>

/**
 * @description Bad Request
 */
export const getUsers400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetUsers400>

export const getUsersQueryResponseSchema = z.lazy(() => getUsers200Schema) as unknown as ToZod<GetUsersQueryResponse>